<template>
    <div>
        <HeaderEntregaLupi :aluno="aluno"/>
        
        <v-divider class="my-2"></v-divider>
        <v-row>
            <!-- Local Entrega -->
            <v-col cols="12" sm="4" lg="3">
                <!-- eslint-disable-next-line -->
                <v-select v-model="form.local_entrega"
                    label="Local de Entrega"
                    clearable hide-details
                    placeholder="Selecione um Local..."
                    :items="locais_entrega"
                    item-value="id"
                    item-title="descricao"
                    @update:modelValue="onSelectLocal">
                </v-select>
            </v-col>

            <!-- Recebido por -->
            <v-col cols="12" sm="8" lg="5">
                <!-- eslint-disable-next-line -->
                <v-combobox v-model="form.recebedor_nome"
                    label="Entregue para"
                    clearable hide-details
                    :items="recebedores"
                    >
                </v-combobox>
            </v-col>

            <!-- Recebedor email -->
            <v-col cols="12" sm="4" lg="4">
                <!-- eslint-disable-next-line -->
                <v-text-field v-model="form.recebedor_email"
                    label="E-mail"
                    clearable
                    placeholder="E-mail do responsável"
                    messages="E-mail que receberá a notificação"
                    >
                </v-text-field>
            </v-col>

            <!-- Obs -->
            <v-col cols="12" sm="8" md="12">
                <!-- eslint-disable-next-line -->
                <v-textarea v-model="form.obs" rows="2"
                    label="Observações" hide-details
                    clearable maxlength="300"
                    placeholder="Incluir observação..."
                    >
                </v-textarea>
            </v-col>

            <!-- Código Item -->
            <v-col cols="12" sm="12" lg="8">
                <ComboBoxPesquisaLupi 
                    class="mb-1"
                    ref="refPesquisaLupi"
                    ref-name="refPesquisaLupi"
                    @select-produto="onSelectProdutoMaterial" />
            </v-col>
            
            <v-col cols="12" sm="12" v-if="form.descricao_item_lupi">
                <CardRegistroEntrega :form="form" @on-registrar-entrega-material="registrarEntregaMaterial"/>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <TabelaMateriaisEntregues 
                    :lista-materiais="lista_materiais"
                    @on-entregar-parcial="entregarParcial"
                    @on-devolver-parcial="devolverParcialMaterial"
                    @on-cancelar-entrega="cancelarEntregaMaterial"
                     />
            </v-col>
        </v-row>

        <helper-gdb text="EntregaLupi" v-if="$store.getters.StateAuthenticatedUser.is_superuser"/>
    </div>
</template>
<script>
/* eslint-disable */
import { mapActions, mapGetters } from 'vuex'
import ComboBoxPesquisaLupi from './ComboBoxPesquisaLupi.vue';
import HeaderEntregaLupi from './HeaderEntregaLupi.vue';
import CardRegistroEntrega from './CardRegistroEntrega.vue';
import TabelaMateriaisEntregues from './TabelaMateriaisEntregues.vue';

export default {
    components: {
        ComboBoxPesquisaLupi,
        HeaderEntregaLupi,
        CardRegistroEntrega,
        TabelaMateriaisEntregues
    },
    props: {
        form: {
            required: true
        },
        aluno: {
            required: true
        }
    },
    data: () => ({
        locais_entrega: [],
        tipos_recebedor: [],
        lista_materiais: [],
        itemLupi: {}
    }),
    mounted(){
        this.get_locais()
        this.init()
        
    },
    methods: {
        ...mapActions([
            'GetEntregaMaterialLupiLocal',
            'RegistrarEntregaMaterialLupi',
            'EntregarParcialMaterialLupi',
            'DevolverParcialMaterialLupi',
            'GetEntregaMaterialLupi',
            'DeleteEntregaMaterialLupi'
        ]),
        create_range(a_entregar, entregue){
            let length = a_entregar - entregue
            // retorna uma lista com valores a partir de 1
            return Array.from({ length: length  }, (_, index) => index +1);
        },
        onSelectProdutoMaterial(p){
            this.form.codigo_item_lupi = p.codigo
            this.form.descricao_item_lupi = p.nome
        },
        cleanFormLupiData(){
            this.form.codigo_item_lupi = null
            this.form.descricao_item_lupi = null
            this.form.quantidade_entregue = 1
            this.form.quantidade_entregar = 1
        },
        focus_codigo_lupi(){
            this.$refs.refPesquisaLupi.$refs.refPesquisaLupi.focus()
        },
        async entregarParcial({entregando, objeto}){
            if (entregando > 0){
                const confirmar_recebimento = confirm(`Confirma a entrega de ${entregando} ${objeto.descricao_item_lupi}?`)
                if (confirmar_recebimento){
                    const id = objeto.id
                    const recebido = await this.EntregarParcialMaterialLupi({ id, entregando })
                    if (recebido){
                        this.init()
                        this.$store.commit('setAlerts', [
                            {
                                tag:'success',
                                title:'Entrega de material',
                                message: `(${entregando}) [${objeto.descricao_item_lupi}] entregue com sucesso`}])
                    }
                    
                }
            }
        },
        async devolverParcialMaterial({objeto}){
            const devolvendo = await this.preencherQuantidadeDevolucao()
            const confirmar_devolucao = confirm(`Confirma a devolução de ${devolvendo} item(ns) - ${objeto.descricao_item_lupi}?`)
            if (confirmar_devolucao){
                const id = objeto.id
                const recebido = await this.DevolverParcialMaterialLupi({ devolvendo,objeto })
                if (recebido){
                    this.init()
                }
            }
        },
        init(){
            const local = localStorage.getItem('local_lupi')
            if (local){
                this.onSelectLocal(local)
            }
            this.focus_codigo_lupi()
            this.getEntregasAluno({ra: this.form.ra, codperlet: this.form.codperlet})
        },
        onSelectLocal(value){
            localStorage.setItem('local_lupi', value)
            this.form.local_entrega = parseInt(value)
        },
        async get_locais(){
            this.locais_entrega = await this.GetEntregaMaterialLupiLocal()
        },
        async getEntregasAluno(params){
            this.lista_materiais = await this.GetEntregaMaterialLupi(params)
        },
        async registrarEntregaMaterial(registro){
            if (!registro.codigo_item_lupi) return
            const confirma = confirm(`Confirmar o registro de entrega do material ${registro.descricao_item_lupi} para o aluno ${registro.ra} - ${registro.nome}?`)
            if (!confirma) return
            const created = await this.RegistrarEntregaMaterialLupi(registro)
            this.$emit('on-created', created)

            if (created){
                this.init()
                this.cleanFormLupiData()
            }
        },
        async cancelarEntregaMaterial({objeto}){
            const deleted = await this.DeleteEntregaMaterialLupi(objeto)
            if(deleted === null){
                // Exclusão não confirmada
            }
            if (deleted){
                this.init()
            }
        },
        preencherQuantidadeDevolucao(){
            let quantidadeDevolver = 1

            do {
                quantidadeDevolver = prompt("Digite um número inteiro:");
                // Tenta converter a entrada em número
                if (quantidadeDevolver === null) {
                    break;
                }
                
                quantidadeDevolver = parseInt(quantidadeDevolver, 10);
                
                // Verifica se é um número válido
                if (Number.isNaN(quantidadeDevolver)) {
                    alert("Por favor, digite um número inteiro válido.");
                } else if (quantidadeDevolver == 0) {
                    alert("Informe um número maior que zero.");
                } else {
                    break;
                }
            } while (true);
            
            return quantidadeDevolver
        }
    },
    computed: {
        ...mapGetters(['StateS9Produtos']),
        recebedores(){
            let recebedores = Array.from(new Set([
                this.aluno.nome,
                this.aluno.respfin_nome
            ].filter(i => i )))
            return recebedores
        }
    },
    watch: {
        // propObject:{
        //     handler(value){
        //         const prop = value
        //         this.form = prop
        //     }, deep: true
        // }
    }
}
</script>